import Stack from '@admin/components/stack'
import PropTypes from 'prop-types'
import Main from './main'
import React from 'react'

class MultiForm extends React.Component {

  static childContextTypes = {
    form: PropTypes.object
  }

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    action: PropTypes.any,
    cancelSvg: PropTypes.string,
    complete: PropTypes.any,
    defaultValue: PropTypes.object,
    endpoint: PropTypes.string,
    formatData: PropTypes.func,
    getSteps: PropTypes.func,
    method: PropTypes.string,
    saveText: PropTypes.string,
    title: PropTypes.string,
    props: PropTypes.object,
    showSteps: PropTypes.bool,
    onCancel: PropTypes.func,
    onNext: PropTypes.func,
    onSuccess: PropTypes.func
  }

  static defaultProps = {
    defaultValue: {},
    formatData: (data) => data,
    method: 'POST',
    saveText: 't(Save)',
    showSteps: true,
    title: 't(Form)'
  }

  stackRef = React.createRef()

  state = {
    entity: null,
    errors: null,
    formdata: null,
    message: null,
    status: 'pending',
    step: -1
  }

  _handlePop = this._handlePop.bind(this)
  _handlePush = this._handlePush.bind(this)
  _handleSave = this._handleSave.bind(this)
  _handleSetStep = this._handleSetStep.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)
  _handleUpdateData = this._handleUpdateData.bind(this)

  render() {
    return <Stack { ...this._getStack() } />
  }

  componentDidMount() {
    const { defaultValue, endpoint } = this.props
    if(endpoint) return this._handleFetch()
    this._handleSetData(defaultValue)
  }

  componentDidUpdate(prevProps, prevState) {
    const { entity, formdata, status } = this.state
    if(status !== prevState.status) {
      if(status === 'success') this.props.onSuccess(entity, formdata)
      if(status === 'ready') this._handlePush(Main, this._getMain.bind(this))
    }
  }

  getChildContext() {
    return {
      form: {
        push: this._handlePush,
        pop: this._handlePop
      }
    }
  }

  _getAction() {
    const { action } = this.props
    const { formdata } = this.state
    if(_.isString(action)) return action
    if(_.isFunction(action)) return action(formdata)
  }

  _getMain() {
    const { cancelSvg, formatData, getSteps, props, saveText, showSteps, title, onCancel, onNext, onSuccess } = this.props
    const { errors, formdata, message, status, step  } = this.state
    return {
      cancelSvg,
      errors,
      formdata,
      formatData,
      message,
      props,
      saveText,
      showSteps,
      status,
      step,
      steps: getSteps(formdata, props),
      title,
      onCancel,
      onNext,
      onSave: this._handleSave,
      onSetStep: this._handleSetStep,
      onSuccess,
      onUpdateData: this._handleUpdateData
    }
  }

  _getStack() {
    return {
      display_name: 'multiform',
      ref: this.stackRef
    }
  }

  _handleFetch() {
    const { endpoint } = this.props
    this.setState({
      status: 'loading'
    })
    this.context.network.request({
      endpoint,
      method: 'GET',
      onSuccess: ({ data }) => {
        this.setState({
          formdata: data,
          status: 'ready'
        })
      },
      onFailure: () => {
        this.setState({
          status: 'failure'
        })
      }
    })
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

  _handleComplete(data) {
    const { complete } = this.props
    this._handlePush(complete, { 
      data,
      onDone: this._handleSuccess.bind(this, data) 
    })
  }

  _handleSave(body) {
    if(this._isSaving) return
    this._isSaving = true
    const { action, complete, method } = this.props
    this.setState({ status: 'submitting' })
    if(!action) return this._handleSuccess(body)
    this.context.network.request({
      endpoint: this._getAction(),
      method,
      body,
      onSuccess: ({ data }) => {
        if(complete) return this._handleComplete(data)
        this._handleSuccess(data)
      },
      onFailure: ({ errors, message }) => {
        this._isSaving = false
        this.setState({
          errors: errors || {},
          message,
          status: 'failure'
        })
      }
    })
  }

  _handleSetStep(step) {
    this.setState({
      message: null,
      step
    })
  }

  _handleSetData(formdata) {
    this.setState({
      status: 'ready',
      formdata: formdata || {}
    })
  }

  _handleSuccess(data) {
    this.setState({
      entity: data,
      status: 'success'
    })
  }

  _handleUpdateData(formdata, step) {
    this.setState({
      formdata,
      step
    })
  }

}

export default MultiForm
